export default "__VITE_ASSET__aPxx3pzM__"